import '../css/legal.css';

export default function Impressum() {
    return (
        <div className="legal-page">
            <h1>Impressum</h1>
            <div className="legal-content">
                <p>
                    <strong>Name:</strong> Alexander Böhm<br/>
                    <strong>Adresse:</strong> Simerbauernweg 1, 82041 Furth<br/>
                    <strong>E-Mail:</strong> <a href="mailto:info@democratiq.de">info@democratiq.de</a>
                </p>
            </div>
        </div>
    );
}
